/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_OriginsInputs */

const en_search_origins = /** @type {(inputs: Search_OriginsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search origins...`)
};

const es_search_origins = /** @type {(inputs: Search_OriginsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar origenes...`)
};

/**
* | output |
* | --- |
* | "Search origins..." |
*
* @param {Search_OriginsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_origins = /** @type {((inputs?: Search_OriginsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_OriginsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_origins(inputs)
	return es_search_origins(inputs)
});